import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'highlight'
})
export class HighlightPipe implements PipeTransform {
  transform(text: string, search: string): string {
    let pattern = search?.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
    pattern = pattern?.split(' ').filter((t) => {
      return t?.length > 0;
    }).join('|');
    const regex = new RegExp(pattern, 'gi');

    return search ? text?.replace(regex, (match) => `<span class="rounded-md px-1 text-sm dark:text-gray-50 text-gray-500 bg-system-highlight dark:bg-[#57420f] ">${match}</span>`) : text;
  }
}
